export const empowerData = {
  sectionHeading: {
    tag: "Empower",
    title: "Our mission",
    text: "Providing Transparent, Reliable Information to Help You Make Smarter Choices with Confidence",
  },
  empowerCards: [
    {
      icon: {
        src: 'assets/icons/light.svg',
        alt: 'lightIcon',
      },
      title: 'Our Mission: Empowering Informed Decisions',
      description: 'We aim to help users make informed decisions by providing comprehensive information about a wide range of products and services. While we strive to keep details accurate and current, prices and offers may change without notice, as they are dynamic and provided by our partners.',
    },
    {
      icon: {
        src: 'assets/icons/importantInfo.svg',
        alt: 'importantInfoIcon',
      },
      title: 'Important Information & Disclaimers',
      description: 'The information on our site is for general guidance only and should not be considered legal or professional advice. Company listings do not imply endorsement. We are not a loan provider or broker; instead, we connect users with lending partners who may offer loans.',
    },
    {
      icon: {
        src: 'assets/icons/appProcessAndTerms.svg',
        alt: 'secureIcon',
      },
      title: 'Secure and Confidential',
      description: 'Submitting a connection request on our site does not count as a loan application. To receive an actual loan offer, you must apply directly with a lender. We cannot guarantee loan approval or the terms shown on our website. Always review the loan agreement carefully before proceeding.',
    },
  ],
};
